<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
	<div>
		<el-dialog append-to-body destroy-on-close class="custom-dialog" :visible.sync="isSidebarActiveLocal" :before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)">
			<div slot="title">
				<h4 class="uppercase font-bold block text-xl w-full">{{ $t("ConfigReminder") }}</h4>
				<p class="text-base text-black font-medium">{{ todo.name }}</p>
			</div>
			<perfect-scrollbar ref="vueScrollBar" class="scroll-area--data-list">
				<div class="px-8 py-4">
					<AddReminder @onDelete="handleDeleteReminder" v-model="reminds" />
				</div>
			</perfect-scrollbar>

			<div class="flex justify-center flex-wrap items-center" slot="footer">
				<vs-button class="w-full sm:w-1/3 mb-3 sm:mb-0 sm:mr-6 font-bold" :disabled="!(reminds && reminds.length)" @click.stop="saveReminder">
					{{ $t("Actions.Save") }}
				</vs-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as _ from "lodash";
import { showConfirm, detectLeavePage } from "@/mixins/mixins.js";

import AddReminder from "@/components/add-reminder/AddReminder";

export default {
	name: "TodoReminderDialog",
	mixins: [showConfirm, detectLeavePage("isFormDirty")],

	provide() {
		return { parentValidator: this.$validator };
	},
	props: {
		todo: {
			type: Object,
			required: true
		},
		isSidebarActive: {
			type: Boolean,
			required: true
		}
	},
	components: { AddReminder },
	data() {
		return {
			reminds: [],
			isFormDirty: false,
			initReminds: []
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		isHasUnsavedReminder() {
			return !!this.reminds.find(remind => !remind.id);
		},
		trackingIsFormDirtyData() {
			return { reminds: this.reminds, initReminds: this.initReminds };
		}
	},
	watch: {
		trackingIsFormDirtyData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal.reminds) !== JSON.stringify(newVal.initReminds) || this.isHasUnsavedReminder;
			},
			deep: true
		}
	},
	methods: {
		async saveReminder() {
			const result = await this.$validator.validateAll();
			if (!result) return;
			this.$vs.loading();

			const list = this.reminds.map(item => {
				const returnItem = { ...item };
				if (returnItem.__typename) {
					delete returnItem.__typename;
				}

				if (item && returnItem.relations) {
					returnItem.relations = returnItem.relations.map(relation => ({ id: relation.id, type: relation.type }));
				}

				return returnItem;
			});

			const queryOptions = {
				list,
				reminderable_id: this.todo.id,
				reminderable_type: this.$constant.REMINDER.REMINDERABLE_TYPE.TODO_LIST
			};
			try {
				const response = await this.$store.dispatch("todoListManagement/updateReminder", queryOptions);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("UpdateReminderSuccessful")
					}
				});

				this.reminds = response;
				this.initReminds = _.cloneDeep(this.reminds);
				this.$emit("onUpdateReminderSuccess");
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleDeleteReminder(remindItem = {}, deleteIndex) {
			try {
				if (remindItem.id) {
					this.mixinShowConfirm().then(async isAccept => {
						if (isAccept) {
							await this.$store.dispatch("todoListManagement/deleteReminder", { id: remindItem.id });
							this.reminds = this.reminds.filter(remind => remind.id !== remindItem.id);
							this.initReminds = _.cloneDeep(this.reminds);
							this.$helper.notifySuccess({
								context: this,
								options: {
									text: this.$t("DeleteReminderSuccessful")
								}
							});
							this.$emit("onUpdateReminderSuccess");
						}
					});
				} else {
					this.reminds = this.reminds.filter((remind, index) => index !== deleteIndex);
					this.initReminds = _.cloneDeep(this.reminds);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		}
	},
	created() {
		this.reminds = this.todo.reminders;
		this.initReminds = _.cloneDeep(this.todo.reminders);
	}
};
</script>

<style></style>
